import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/priceplans',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/priceplans',
      name: 'priceplans',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/Priceplans.vue')
    }

  ]
};
export default app;
